export default __webpack_public_path__ + "static/media/ill-no-data.88593f06.svg";